import * as React from "react";
import { useBurnIslandMigration, UseMigrationProps } from "./hooks/useBurnIslandMigration";

// --- Main Component ---
const BurnIslandMigrator: React.FC<UseMigrationProps> = (props) => {
    // This hook will automatically execute the migration and call back to .NET with progress and completion.
    useBurnIslandMigration(props);

    // This component is a headless engine and renders no UI.
    return null;
};

export default BurnIslandMigrator;
